import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useProductFilterStore = defineStore('productFilter', () => {
  // State
  const officePrinter = ref({
    speed: 'printSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      printSpeed: {
        min: 0,
        max: 150,
      },
      paperSize: '',
      colourPrinting: '',
      brand: '',
    },
  })

  const multifunctionalPrinter = ref({
    speed: 'printSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      printSpeed: {
        min: 0,
        max: 150,
      },
      paperSize: '',
      colourPrinting: '',
      brand: '',
    },
  })
  const productionPrinter = ref({
    speed: 'printSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      printSpeed: {
        min: 0,
        max: 500,
      },
      paperSize: '',
      colourPrinting: '',
      brand: '',
    },
  })

  const scanner = ref({
    speed: 'scanSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      scanSpeed: {
        min: 0,
        max: 150,
      },
      paperSize: '',
      brand: '',
    },
  })
  const productionScanner = ref({
    speed: 'scanSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      scanSpeed: {
        min: 0,
        max: 300,
      },
      paperSize: '',
      brand: '',
    },
  })

  const plotter = ref({
    speed: 'printSpeed', // Workaround for making current filter work with new types
    filterRules: {
      model: '',
      printSpeed: {
        min: 0,
        max: 150,
      },
      paperSize: '',
      colourPrinting: '',
      brand: '',
    },
  })

  const finisher = ref({
    filterRules: {
      model: '',
      brand: '',
    },
  })

  // Actions (Mutations are now direct modifications of ref values)
  const setSpeed = (productType, { target, value }) => {
    const productRef = getProductRef(productType)
    if (productRef.value.speed) {
      // Check if the product type has a 'speed' key
      const speedKey = productRef.value.speed
      if (target === 'min') {
        productRef.value.filterRules[speedKey].min = value
      } else {
        productRef.value.filterRules[speedKey].max = value
      }
    }
  }

  const setMaxSpeed = (productType, value) => {
    const productRef = getProductRef(productType)
    if (productRef.value.speed) {
      const speedKey = productRef.value.speed
      productRef.value.filterRules[speedKey].max = value
    }
  }

  const setFilterModelName = (productType, value) => {
    const productRef = getProductRef(productType)
    productRef.value.filterRules.model = value
  }

  const setFilterBrand = (productType, value) => {
    const productRef = getProductRef(productType)
    productRef.value.filterRules.brand = value
  }

  // Helper to get the correct product ref based on type
  const getProductRef = (productType) => {
    switch (productType) {
      case 'office-printer':
        return officePrinter
      case 'multifunctional-printer':
        return multifunctionalPrinter
      case 'production-printer':
        return productionPrinter
      case 'production-scanner':
        return productionScanner
      case 'scanner':
        return scanner
      case 'plotter':
        return plotter
      case 'finisher':
        return finisher
      default:
        throw new Error(`Unknown product type: ${productType}`)
    }
  }

  // Getters
  const getFilterState = computed(() => ({
    'office-printer': officePrinter.value,
    'multifunctional-printer': multifunctionalPrinter.value,
    'production-printer': productionPrinter.value,
    'scanner': scanner.value,
    'production-scanner': productionScanner.value,
    'plotter': plotter.value,
    'finisher': finisher.value,
  }))

  // Assuming filterRules would be part of the state if it existed,
  // but it's not defined in your original state.
  // For demonstration, let's assume it would be another ref:
  // const filterRules = ref({}); // Or whatever its default value should be
  // const getFilterRules = computed(() => filterRules.value)

  // This getter needs a productType argument now
  const getFilterSpeed = (productType) =>
    computed(() => {
      const productRef = getProductRef(productType)
      if (productRef.value.speed) {
        const speedKey = productRef.value.speed
        return productRef.value[speedKey]
      }
      return null // Or appropriate default
    })

  return {
    // State
    officePrinter,
    multifunctionalPrinter,
    productionPrinter,
    scanner,
    productionScanner,
    plotter,
    finisher,
    // filterRules, // Expose if needed

    // Actions
    setSpeed,
    setMaxSpeed,
    setFilterModelName,
    setFilterBrand,

    // Getters
    getFilterState,
    // getFilterRules,
    getFilterSpeed,
  }
})
